import moment from "moment";
import { useEffect, useState } from "react";
import { expireEventRequestThunk } from "../store/events/eventThunk";
import { useAppDispatch } from "./storeHooks";
const useTimer = ({
  expireAt,
  eventRequestId,
}: {
  expireAt?: string;
  eventRequestId: string;
}) => {
  const calculateRemainingTime = () => {
    const now = moment();
    const endTime = moment(expireAt || "");
    const remainingDuration = moment.duration(endTime.diff(now));
    return remainingDuration;
  };
  const dispatch = useAppDispatch();
  const [remainingTime, setRemainingTime] = useState(
    expireAt ? calculateRemainingTime() : ""
  );
  const formatTime = (duration: any) => {
    if (duration) {
      const hours = String(Math.floor(duration.asHours())).padStart(2, "0");
      const minutes = String(duration.minutes()).padStart(2, "0");
      const seconds = String(duration.seconds()).padStart(2, "0");

      return hours[0] != "-" ? `${hours}:${minutes}:${seconds}` : "";
    }
    return "";
  };

  useEffect(() => {
    if (expireAt) {
      const intervalId = setInterval(() => {
        const updatedTime = calculateRemainingTime();
        if (updatedTime.asSeconds() <= 0) {
          clearInterval(intervalId);
          setRemainingTime(moment.duration(0));
        } else {
          setRemainingTime(updatedTime);
        }
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [expireAt]);

  const time = expireAt ? formatTime(remainingTime) : "";

  useEffect(() => {
    if (eventRequestId && time === "00:00:00") {
      dispatch(expireEventRequestThunk(eventRequestId));
    }
  }, [time, eventRequestId]);

  return time === "00:00:00" ? "Expired" : time;
};

export default useTimer;
